/* eslint-disable @typescript-eslint/default-param-last */
import { GET_COMPANY_TEAM_MEMBERS_STATS_SUCCESS } from '../constants/ActionTypes';
import initialState from '../store/initialState';
import { ITeamMembersStatsActionType } from '../types/teamMembersStats.types';

const teamMemberStatsReducer = (
  state = initialState.teamMembersStats,
  action: ITeamMembersStatsActionType
) => {
  switch (action.type) {
    case GET_COMPANY_TEAM_MEMBERS_STATS_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default teamMemberStatsReducer;
